<template>
  <div :class="{'notification-icon': true, 'disable-events': isNotificationsPage}" @click="openNotificationsV2">
    <div 
      v-if="useNotifications().getNumbersTotal()" 
      :class="{badge: true, 'badge-long': useNotifications().getNumbersTotal() > 99}">
      {{ countNewNotifications }}
    </div>
    <i class="icon-alarm"></i>


    <NotificationV2NotificationPopup 
      v-if="showedUserPopupNotifications"   
      @close="hideUserPopupNotificationsShow" 
      />
      
  </div>
</template>

<script setup lang="ts">
import { useNotifications } from '@/composables/useNotifications'
import { useClientIsMobile } from '@/composables/useClient'
import { NotificationV2NotificationPopup } from '#components'

const isMobileDevice = useClientIsMobile()
const router = useRouter()
const showedUserPopupNotifications = ref(false)

const openNotificationsV2 = () => {
  if (isMobileDevice.value) {
    router.push('/notifications')
  } else {
    showedUserPopupNotifications.value = !showedUserPopupNotifications.value
  }
}

const isNotificationsPage = computed(() => {
  return router.currentRoute.value.path === '/notifications'
})

const countNewNotifications = computed(() => {
  if(useNotifications().getNumbersTotal() > 99){
    return '99+'
  }
  return useNotifications().getNumbersTotal()
})

const hideUserPopupNotificationsShow = () => {
  showedUserPopupNotifications.value = false
}

</script>

<style scoped>

.notification-icon {
  position: relative;
  cursor: pointer;
  padding: 15px 23px;
  display: flex;
  align-items: center;
}

.notification-icon i {
  font-size: 1.34rem;
  flex-shrink: 0;
  line-height: 1rem;
}

.notification-icon.disable-events {
  pointer-events: none;
}

.badge {
  position: absolute;
    min-width: 16px;
    height: 16px;
    font-size: 8px;
    font-weight: bold;
    line-height: 15px;
    text-align: center;
    top: 6px;
    right: 10px;
    background-color: #e10404;
    color: white;
    border-radius: 8px;
    pointer-events: none;
}

.badge.badge-long {
  min-width: 23px;
}

@media (max-width: 768px) {
  .notification-icon i {
    font-size: 1.35rem;
  }

      html body .bd:not(.onnav):not(.scrolled)[data-section="home"] .topbar .notification-icon i{
        color: white;
    }
}
</style>